/**
 * Helper para navegação prefix-aware (mobile vs desktop).
 * Detecta se o usuário está no módulo mobile via pathname
 * e ajusta os caminhos de tickets automaticamente.
 */

export const isMobileRoute = () => {
  return window.location.pathname.startsWith("/mobile");
};

export const getTicketsBasePath = () => {
  return isMobileRoute() ? "/mobile/tickets" : "/tickets";
};

export const getTicketPath = (uuid) => {
  const base = getTicketsBasePath();
  return uuid ? `${base}/${uuid}` : base;
};
